import { getField } from 'vuex-map-fields';

export default {
  loadingNewTemplateConfig: state => state.loadingNewTemplateConfig,
  newTemplateConfig: state => state.newTemplateConfig,
  templateMessageList: state => state.templateMessageList,
  templateMessagesLoaded: state => state.templateMessagesLoaded,
  templateMessageCreated: state => state.templateMessageCreated,
  templateMessageUpdated: state => state.templateMessageUpdated,
  templateMessageDeleted: state => state.templateMessageDeleted,
  templateMessageValidationFailed: state => state.templateMessageValidationFailed,
  templateMessageValidationSuccess: state => state.templateMessageValidationSuccess,
  templateMessageSent: state => state.templateMessageSent,
  templateMessageFailed: state => state.templateMessageFailed,
  bulkMessagesSent: state => state.bulkMessagesSent,
  templateAnalytics: state => state.templateAnalytics,
  dynamicTags: state => state.dynamicTags,

  sentNotifications: state => state.sentNotifications,
  sentNotificationsLoaded: state => state.sentNotificationsLoaded,
  bulkSendError: state => state.bulkSendError,

  campaignDetails: state => state.campaignDetails,
  campaignDetailsLoaded: state => state.campaignDetailsLoaded,
  campaignDetailsResData: state => state.campaignDetailsResData,
  campaignDetailsResDataLoaded: state => state.campaignDetailsResDataLoaded,

  notificationTags: state => state.notificationTags,
  notificationTagsLoaded: state => state.notificationTagsLoaded,

  apiError: state => state.apiError,
  getField,
};
